"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.range = void 0;
var range = function range(min, max) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Array(Math.ceil((max - min + 1) / step)).fill(min).map(function (value, index) {
    return value + index * step;
  });
};
exports.range = range;